export default "__VITE_ASSET__Du2j923q__"